import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import {
  followCreator,
  followCreatorReset,
  followCreatorSuccess,
  unfollowCreator,
  unfollowCreatorSuccess,
} from "../creatorProfile/actions";

import {
  getMySupporters,
  getMySupportersSuccess,
  getMySupportersFailure,
  getMySupportersPortion,
  getMySupportersPortionSuccess,
  getMySupportersPortionFailure,
  getSupportersById,
  getSupportersByIdSuccess,
  getSupportersByIdFailure,
  getSupportersByIdPortion,
  getSupportersByIdPortionSuccess,
  getSupportersByIdPortionFailure,
  supportersReset,
} from "./actions";

const initialState = {
  data: [],
  nextOffset: undefined,
  totalCount: undefined,
  isFollowSuccess: undefined,
  error: undefined,
  isLoading: true,
  isFollowUpdating: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(supportersReset.type, () => initialState)
    .addCase(followCreator.type, (state) => ({
      ...state,
      isFollowUpdating: true,
    }))
    .addCase(unfollowCreator.type, (state) => ({
      ...state,
      isFollowUpdating: true,
    }))
    .addCase(unfollowCreatorSuccess, (state, { payload }) => {
      state.isFollowUpdating = false;

      const { userId } = payload;
      const { data } = state;

      const followingIndex = data.findIndex(
        (item) => item?.user?.id === userId,
      );

      const item = data.at(followingIndex);

      if (item) {
        item.user.isFollowed = false;
      }

      return state;
    })
    .addCase(followCreatorSuccess.type, (state, { payload }) => {
      state.isFollowSuccess = true;
      state.isFollowUpdating = false;

      const { userId } = payload;
      const { data } = state;

      const followingIndex = data.findIndex(
        (item) => item?.user?.id === userId,
      );

      const item = data.at(followingIndex);

      if (item) {
        item.user.isFollowed = true;
      }

      return state;
    })
    .addCase(followCreatorReset.type, (state) => ({
      ...state,
      isFollowSuccess: initialState.isFollowSuccess,
    }))
    .addMatcher(
      isAnyOf(getMySupportersPortionSuccess, getSupportersByIdPortionSuccess),
      (state, { payload }) => ({
        ...state,
        ...payload,
        data: [...state.data, ...payload.data],
        isLoading: false,
      }),
    )
    .addMatcher(isAnyOf(followCreator, unfollowCreator), (state) => ({
      ...state,
      isFollowUpdating: true,
    }))
    .addMatcher(
      isAnyOf(getMySupportersSuccess, getSupportersByIdSuccess),
      (state, { payload }) => ({
        ...state,
        ...payload,
        isLoading: false,
      }),
    )
    .addMatcher(
      isAnyOf(
        getMySupporters,
        getMySupportersPortion,
        getSupportersById,
        getSupportersByIdPortion,
      ),
      (state) => ({
        ...state,
        isLoading: true,
      }),
    )
    .addMatcher(
      isAnyOf(
        getMySupportersFailure,
        getMySupportersPortionFailure,
        getSupportersByIdFailure,
        getSupportersByIdPortionFailure,
      ),
      (state, { payload }) => ({
        ...state,
        isLoading: false,
        error: payload,
      }),
    );
});
